<template>

    <b-modal v-model="showEnterOTPModal" :width="700" scroll="clip" animation="zoom-out" :can-cancel="false" >

      <div class="modal-card" style="width: auto">

        <section class="modal-card-body">
          <p class="modal-card-title">Enter Your OTP Code</p>

          <div class="otpDescriptionArea">
            <p>We have sent an OTP to <b>{{Email}}</b>.</p>
            <p>Please check your email and enter the OTP code below</p>
          </div>

          <div class="columns">

            <!--  Image side   -->
            <div class="column">
              <img id="otpImage" src="../../assets/gifs/otp-verification-animation.gif">
            </div>

            <!--  Input field side   -->
            <div class="column is-two-thirds inputFieldsArea">
              <div class="box-1" style="height: 100%; margin-top: -2%">
                <div class="mt-5">

                  <b-field
                      :type="invalidFields.otpValue == ''? 'is-info' : 'is-danger'"
                      :message="invalidFields.otpValue"
                      label="Enter Your OTP Code"
                      label-position="on-border"
                  >
                    <b-input
                        v-model="otpValue"
                        maxlength="6"
                        @input="resetInvalidFields('otpValue')"
                        rounded
                    ></b-input>
                  </b-field>

                  <div class="buttons">
                    <b-button type="is-primary" outlined rounded expanded  @click="verifyOTP">Confirm</b-button>
                  </div>

                </div>
              </div>
            </div>
          </div>


        </section>

      </div>
    </b-modal>

</template>

<script>

import axios from "axios";

export default {

  name:'enter-otp',

  props:{

  },

  data() {
    return {
      showEnterOTPModal : true,
      otpValue:'',
      receivedOTP:'',
      Email:'',

      invalidFields:{
        otpValue: "",
      },

      regex:{
        otpValue: /^[0-9]{6}$/,
      }
    }
  },

  methods:{

    /**
     * A method to reset invalid form fields
     * @param field field name
     */
    resetInvalidFields : function(field){
      this.invalidFields[field] =''
    },


    /**
     * A method to validate the input fields
     * @returns {boolean}
     */
    validateFields(){
      var isValid = true
      const comp = this

      if(comp.otpValue.trim() === '' ){
        comp.invalidFields.otpValue = "This field cannot be empty"
        isValid = false
      }
      else if(!comp.regex.otpValue.test(comp.otpValue)){
        comp.invalidFields.otpValue = "OTP must have 6 digits. Use numbers only"
        isValid = false
      }

      return isValid
    },

    hideemail:function() {
      var email = this.$root.customerData.email
      var hiddenEmail = "";
      for (var i = 0; i < email.length; i++) {
        if (i > 2 && i< email.indexOf("@") ) {
          hiddenEmail += "x";
        } else {
          hiddenEmail += email[i];
        }
      }
      this.Email = hiddenEmail
    },


    /**
     *
     * A method to verify received otp with customer entered otp
     */
    verifyOTP(){
      console.log("verifyOTP method called --------------")

      const comp = this

      console.log("SENT OTP : "+comp.receivedOTP)
      console.log("ENTERED OTP : "+comp.otpValue)

      if(comp.validateFields()){
        if(comp.otpValue == comp.receivedOTP){
          console.log("OTP Matched !")

          let currentDateTime = new Date()
          let month = currentDateTime.getMonth()+1

          if(month < 10){
            month = "0"+month
          }
          //format -> 'Y-m-d H:i:s'
          let formattedDateTime = currentDateTime.getFullYear()+"-"+month+"-"+currentDateTime.getDate()+" "+currentDateTime.getHours()+":"+currentDateTime.getMinutes()+":"+currentDateTime.getSeconds()

          let returnData = {
            isOtpVerified : true,
            otpVerifiedTime : formattedDateTime
          }

          comp.$emit('on-otp-valid',returnData) // custom event when the otp is valid
        }
        else{
          comp.$buefy.toast.open({
            message: "Entered OTP does not match with OTP sent",
            type: "is-danger",
          });
        }
      }
    },

    /**
     *
     * A method to get  the otp code
     */
    getOTP(){
      const component = this

      try {
        axios.post(component.$base_url+'/customer/sendOtp', {
          // contact_number : component.$root.customerData.contactNumber,
          // email : component.$root.customerData.email,
          // invitee_nic : component.$root.customerData.nicNumber,
          invitee_token : component.$root.invitee_token
        })
            .then(function (response) {

              console.log("OTP Data ---------------")
              console.log(response)

              if(response.data.success){
                component.receivedOTP = response.data.data.otp
                console.log("OTP : "+ component.receivedOTP)
              }
              else{
                component.$buefy.toast.open({
                  message: "Failed to send OTP",
                  type: "is-danger",
                });
              }
            })
            .catch(function (error) {
              console.log(error)

              component.$buefy.toast.open({
                message: "Failed to send OTP",
                type: "is-danger",
              });
            });
      }
      catch (e){
        component.$buefy.toast.open({
          message: "Failed to send OTP",
          type: "is-danger",
        });
        console.log("Exception occurred in EnterOTPModal getOTP() : "+e.message)
      }
    }
  },

  mounted() {
    this.getOTP()
    this.hideemail()
  }

}
</script>

<style scoped>

.modal-card-title{
  font-weight: bold;
  background-color: #0D5DA3;
  font-size: 28px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding-bottom: 5px;
  margin-bottom: 15px;
}
.modal-card-body{
  border-radius: 15px;
}

.otpDescriptionArea{
  color: #7E7E8F;
  margin-bottom: 10px;
}

.inputFieldsArea{
 padding: 70px 0;
}



</style>
